import { useContext, useState } from "react";

import LscBoardMemberData from "./LscBoardMemberData";
import { LscBoardMemberContext } from "./LscBoardMemberContextProvider";

const useLscBoardMemberData = () => {
  const [lscBoardMemberState, setLscBoardMemberState] = useContext(LscBoardMemberContext);

  const getLscBoardMembers = (orgUnitId) => {
    return LscBoardMemberData.getLscBoardMembersData(orgUnitId, lscBoardMemberState, setLscBoardMemberState);
  };

  const resetLscBoardMemberState = () => {
    setLscBoardMemberState({
      ...LscBoardMemberData.INITIAL_LSC_BOARD_MEMBER_STATE
    });
  };

  return {
    lscBoardMemberState,
    getLscBoardMembers,
    resetLscBoardMemberState
  };
};

export default useLscBoardMemberData;